export function SignatureBlock({ sig, className = "" }) {
  if (!sig) return null;
  return (
    <div className={`mt-12 grid gap-10 bg-white p-4 text-sm text-slate-700 sm:grid-cols-2 ${className}`} data-testid="signature-block">
      {sig.map((p) => (
        <div key={p.key} data-testid={`signature-${p.key}`}>
          <div className="flex h-16 items-end">
            {p.img && <img src={p.img} alt={`${p.label} signature`} className="block h-auto max-h-16 w-auto max-w-[240px]" data-testid={`signature-${p.key}-img`} />}
          </div>
          <div className="border-t border-slate-500 pt-2">
            <div className="flex items-baseline justify-between gap-3">
              <div className="font-semibold text-slate-900" data-testid={`signature-${p.key}-name`}>{p.name || "\u00a0"}</div>
              {p.date && <div className="whitespace-nowrap text-xs text-slate-600" data-testid={`signature-${p.key}-date`}>Date: {p.date}</div>}
            </div>
            {p.title && <div className="text-slate-600">{p.title}</div>}
            <div className="text-xs uppercase tracking-wider text-slate-500">{p.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
